import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/maparecursos.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad2Actividad1.mp3";

const Actividad2 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[0];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[1].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[1].path}`,
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[13].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[13].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>
        Observa el mapa.        </li>
      </ul>

      <img src={Imagen1} className="img-fluid" alt="Peruanos" />

      <div className="row">
        <ul>
          <li>Conversa con un compañero, compañera o familiar y responde las siguientes preguntas.</li>
        </ul>
        <div className="col-lg-10 col-12">
          <p>¿Qué recursos observan en el mapa y dónde se ubican?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>
            ¿Por qué creen que no hay los mismos recursos en todo el territorio?
          </p>
          <textarea className="form-control mb-4" rows={3} />
          <p>
            ¿Qué está ocurriendo en las zonas marcadas? ¿Es un problema? ¿Por
            qué creen que está ocurriendo esto?
          </p>
          <textarea className="form-control mb-4" rows={3} />
        </div>
      </div>

      <p>
        <small>
          (Ilustración adaptada de:{" "}
          <a href="http://es.slideshare.net/urquiza123/capitalnaturalyeconomia-issue">
            http://es.slideshare.net/urquiza123/capitalnaturalyeconomia-issue
          </a>
          )
        </small>
      </p>

      <GuiaDocente>
        <ul>
          <li>
            Explique que en esta unidad realizarán actividades
            que buscan deliberar sobre la variedad de recursos presentes en el
            Perú y la problemática de su acceso y manejo. Señale que las
            primeras actividades buscan, a partir de la observación de imágenes,
            brindar información sobre los problemas que afectan a determinados
            recursos.
          </li>
          <li>
            Pida que observen el mapa del Perú. Pregunte:
            <ul>
              <li>
                <i>
                  “¿Cómo se encuentra dividido? (Posible respuesta: En tres
                  regiones: costa, sierra y selva).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué información se presenta en el mapa? (Posible respuesta:
                  Es un mapa en el que se presentan algunos recursos y dónde se
                  ubican. También aparecen algunos problemas que enfrentan estos
                  recursos)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la indicación y pida que respondan las preguntas que se plantean en la actividad: Observa el mapa y
            conversa con un compañero o compañera sobre lo siguiente. ¿Qué
            recursos observan en el mapa y dónde se ubican? ¿Por qué creen que
            no hay los mismos recursos en todo el territorio? ¿Qué está
            ocurriendo en las zonas marcadas? ¿Es un problema? ¿Por qué creen
            que está ocurriendo esto?
          </li>
          <li>
            Ahora retome las respuestas dadas a cada una de las
            preguntas. Por ejemplo:
            <ul>
              <li>
                <i>
                  “¿Qué recursos observan en el mapa y dónde se ubican? (Posible
                  respuesta: En la costa, se observan distintos recursos
                  provenientes del mar, como peces y petróleo (vemos unas
                  plataformas petroleras); también hay recursos agrícolas (como
                  el algodón, los espárragos y algunas frutas). En la sierra,
                  vemos los glaciares en la cordillera (de ellos obtenemos
                  agua), productos agrícolas (como la papa, el maíz y las habas)
                  y ganado (vacas, carneros, auquénidos). En la selva,
                  observamos la presencia de café, cacao, madera, ríos y
                  petróleo).
                </i>
              </li>
              <li>
                <i>
                  ¿Por qué creen que no hay los mismos recursos en todo el
                  territorio? (Posible respuesta: Porque los recursos dependen
                  de las condiciones del territorio, como son el clima, el
                  relieve, etc. Al haber un territorio tan heterogéneo, existe
                  una gran variedad de recursos).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué está ocurriendo en las zonas marcadas? (Posible
                  respuesta: En las zonas marcadas se puede observar el derrame
                  de petróleo en la selva, el desagüe en el mar y los glaciares
                  derritiéndose. ¿Es un problema? Claro, resulta un problema
                  porque afecta una gran variedad de recursos. ¿Por qué creen
                  que está ocurriendo esto? Algunos problemas pueden ser
                  consecuencia de la falta de responsabilidad del Estado o de
                  las empresas al explotar un recurso y su escasa preocupación
                  ante el cuidado del medio ambiente.”
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
